import { isEmpty } from "lodash";

export function getLinkWithHttps(link: string): string {
  if (isEmpty(link)) return null;

  const normalizedLink = link.trim();
  const lower = normalizedLink.toLowerCase();

  if (lower.startsWith("https://")) {
    return normalizedLink;
  }

  return `https://${normalizedLink}`;
}
